import {ChangeEvent, FormEvent, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSnackbarHook} from '../../hooks/useSnackbar';
import Container from '../common/layout/Container';

const initialFormState = {
  name: '',
  email: '',
  idea: ''
};

type InputChangeEvent = ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

const Improve = () => {
  const {t} = useTranslation('improve');
  const [form, setForm] = useState(initialFormState);
  const {addSuccessToast} = useSnackbarHook();

  useEffect(() => {
    document.title = t('title');
  }, [t]);

  const handleChange = (e: InputChangeEvent) => {
    const {name, value} = e.target;

    setForm((prev) => ({...prev, [name]: value}));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    // Demo-only form: no backend submission, resets and shows success feedback.
    setForm(initialFormState);
    addSuccessToast(t('successToast'));
  };

  return (
    <Container>
      <div className="improve-page">
        <h1 className="improve-page__title">{t('title')}</h1>
        <p className="improve-page__subtitle">{t('subtitle')}</p>

        <form className="improve-page__form" onSubmit={handleSubmit}>
          <div className="improve-page__field">
            <label className="improve-page__label" htmlFor="improve-name">
              {t('form.nameLabel')}
            </label>
            <input
              id="improve-name"
              className="improve-page__input"
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder={t('form.namePlaceholder')}
              required
            />
          </div>

          <div className="improve-page__field">
            <label className="improve-page__label" htmlFor="improve-email">
              {t('form.emailLabel')}
            </label>
            <input
              id="improve-email"
              className="improve-page__input"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder={t('form.emailPlaceholder')}
              required
            />
          </div>

          <div className="improve-page__field">
            <label className="improve-page__label" htmlFor="improve-idea">
              {t('form.ideaLabel')}
            </label>
            <textarea
              id="improve-idea"
              className="improve-page__textarea"
              name="idea"
              value={form.idea}
              onChange={handleChange}
              placeholder={t('form.ideaPlaceholder')}
              rows={6}
              required
            />
          </div>

          <button className="improve-page__submit" type="submit">
            {t('form.submit')}
          </button>
        </form>
      </div>
    </Container>
  );
};

export default Improve;
